/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skills_User_Last_NameInputs */

const en_tables_skills_user_last_name = /** @type {(inputs: Tables_Skills_User_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Last Name`)
};

const de_tables_skills_user_last_name = /** @type {(inputs: Tables_Skills_User_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "User Last Name" |
*
* @param {Tables_Skills_User_Last_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skills_user_last_name = /** @type {((inputs?: Tables_Skills_User_Last_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skills_User_Last_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skills_user_last_name(inputs)
	return de_tables_skills_user_last_name(inputs)
});